<script setup lang="ts"></script>

<template>
  <section class="about-section">
    <h2 class="about-section__title">
      <span class="about-section__title-highlight">CRE.ru</span>
      <span class="about-section__title-text">
        — 20 лет объединяем рынок коммерческой недвижимости</span
      >
    </h2>
    <div class="about-section__intro">
      Наши конференции и медийные проекты — площадка, где встречаются
      девелоперы, брокеры, консультанты и инвесторы.
      <div class="about-section__tagline-left">Уникальные форматы</div>
    </div>

    <div class="about-section__projects">
      <div class="about-section__card card-xmas">
        <div class="card-xmas__content">
          <div class="card-xmas__header">
            <h3 class="card-xmas__title">CRE Иксмас</h3>
            <p class="card-xmas__description">
              Ежегодная итоговая конференция рынка коммерческой недвижимости
            </p>
          </div>
          <div class="card-xmas__stats stats">
            <div class="stats__item">
              <div class="stats__value">50+</div>
              <div class="stats__label">спикеров</div>
            </div>
            <div class="stats__item">
              <div class="stats__value">300+</div>
              <div class="stats__label">участников</div>
            </div>
          </div>
          <p class="stats__description">
            только первые лица: девелоперы, инвесторы, банки, управляющие
            компании
          </p>
        </div>
      </div>

      <div class="about-section__card card-awards">
        <div class="card-awards__content">
          <div class="card-awards__header">
            <h3 class="card-awards__title">CRE Awards</h3>
            <p class="card-awards__description">
              Крупнейшая премия в области коммерческой недвижимости, более 20
              лет отмечает достижения девелоперских, инвестиционных,
              консалтинговых и управляющих компаний, ежегодно гала-ужин в честь
              номинантов и победителей собирает более 300 гостей
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="about-section__tagline-right">И многое другое</div>
  </section>
</template>

<style scoped lang="scss">
@use './styles/styles.scss' as *;
.about-section {
  position: relative;
  padding: 74px 129px 57px;

  @media (max-width: $tablet-view) {
    padding: 90px 0 35px;
  }

  @media (max-width: $mobile-view) {
    padding: 40px 0;
  }

  &__title {
    font-size: 64px;
    line-height: 100%;
    font-weight: 400;
    width: 833px;
    margin: 0;

    @media (max-width: $tablet-view) {
      font-size: 46px;
      margin: 0 60px 0 30px;
      width: unset;
    }

    @media (max-width: $mobile-view) {
      margin: 0 24px 0 20px;
      font-size: 32px;
    }

    &-highlight {
      color: #f26628;
      @include font-medium;
    }

    &-text {
      color: #313030;
      @include font-regular;
    }
  }

  &__intro {
    color: #111111;
    @include font-regular;
    font-size: 22px;
    line-height: 130%;
    margin: -35px 0 0 calc(50% + 68px);
    width: calc(50% - 68px);

    @media (max-width: $tablet-view) {
      margin: 30px 0 0 calc(50% + 100px);
      width: calc(50% - 130px);
      font-size: 18px;
    }

    @media (max-width: $mobile-view) {
      margin: 20px 24px 0 20px;
      font-size: 14px;
      width: calc(100% - 44px);
    }
  }

  &__tagline-left {
    color: #8497e0;
    @include font-medium;
    font-size: 32px;
    line-height: 130%;
    margin-top: 16px;
    width: fit-content;

    @media (max-width: $tablet-view) {
      margin-top: 30px;
      font-size: 24px;
    }

    @media (max-width: $mobile-view) {
      margin-top: 20px;
      font-size: 16px;
    }
  }

  &__projects {
    display: flex;
    width: 100%;
    margin-top: 130px;

    @media (max-width: $tablet-view) {
      margin-top: 95px;
    }

    @media (max-width: $mobile-view) {
      margin-top: 38px;
      flex-direction: column;
    }
  }

  &__card {
    width: 50%;

    @media (max-width: $mobile-view) {
      width: 100%;
    }

    &.card-xmas {
      background: #ffffff url('./images/actions-pic1.png') no-repeat top -47px
        center;
      padding-top: 500px;
      padding-bottom: 56px;
      margin-top: -145px;
      height: fit-content;

      @media (max-width: $tablet-view) {
        margin-top: -120px;
        padding-bottom: 50px;
      }

      @media (max-width: $mobile-view) {
        margin-top: 0;
        padding-bottom: 40px;
      }

      .card-xmas {
        &__content {
          padding: 0 50px;
          max-width: 381px;
          box-sizing: content-box;

          @media (max-width: $mobile-view) {
            padding: 0 20px;
          }
        }

        &__header {
          @include font-regular;
        }

        &__title {
          font-size: 32px;
          line-height: 130%;
          margin: 0;

          @media (max-width: $tablet-view) {
            font-size: 24px;
          }
        }

        &__description {
          font-size: 22px;
          line-height: 130%;
          margin: 10px 0 0 0;

          @media (max-width: $tablet-view) {
            font-size: 18px;
          }

          @media (max-width: $mobile-view) {
            font-size: 16px;
          }
        }
      }

      .stats {
        display: flex;
        gap: 49px;
        margin-top: 40px;
        flex-wrap: wrap;

        @media (max-width: $mobile-view) {
          margin-top: 30px;
          gap: 60px;
        }

        &__item {
          @include font-medium;
          color: #f26628;
          font-size: 54px;
          line-height: 100%;
          max-width: 170px;

          @media (max-width: $tablet-view) {
            font-size: 46px;
          }

          @media (max-width: $mobile-view) {
            font-size: 32px;
          }
        }

        &__label {
          font-size: 32px;

          @media (max-width: $tablet-view) {
            font-size: 26px;
          }

          @media (max-width: $mobile-view) {
            font-size: 14px;
          }
        }

        &__description {
          color: #313030;
          @include font-regular;
          font-size: 22px;
          line-height: 130%;
          margin: 23px 0 0 0;

          @media (max-width: $tablet-view) {
            font-size: 18px;
            margin-top: 30px;
          }

          @media (max-width: $mobile-view) {
            font-size: 16px;
            margin-top: 20px;
          }
        }
      }
    }

    &.card-awards {
      background: #313030 url('./images/actions-pic2.png') no-repeat top -47px
        center;
      padding: 535px 62px 83px 69px;

      @media (max-width: $tablet-view) {
        padding: 535px 19px 98px 69px;
      }

      @media (max-width: $mobile-view) {
        padding: 525px 23px 40px 20px;
      }

      .card-awards {
        &__content {
          display: flex;
          flex-direction: column;
        }

        &__header {
          display: flex;
          flex-direction: column;
          gap: 10px;

          @media (max-width: $mobile-view) {
            gap: 20px;
          }
        }

        &__title {
          color: #ffffff;
          @include font-regular;
          font-size: 32px;
          line-height: 130%;
          margin: 0;

          @media (max-width: $tablet-view) {
            font-size: 24px;
          }
        }

        &__description {
          color: #ffffff;
          @include font-regular;
          font-size: 22px;
          line-height: 130%;
          margin: 0;

          @media (max-width: $tablet-view) {
            font-size: 18px;
          }

          @media (max-width: $mobile-view) {
            font-size: 14px;
          }
        }
      }
    }
  }

  &__tagline-right {
    color: #8497e0;
    @include font-medium;
    font-size: 32px;
    line-height: 130%;
    margin: 34px 0 0 auto;
    width: fit-content;

    @media (max-width: $tablet-view) {
      font-size: 24px;
      margin-top: 30px;
      margin-right: 30px;
    }

    @media (max-width: $mobile-view) {
      font-size: 16px;
      margin: 20px auto 0;
    }
  }
}
</style>
